import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Inspect = createReactComponent("Inspect", ["svg", defaultAttributes, [["path", {
  d: "M19 11V4a2 2 0 00-2-2H4a2 2 0 00-2 2v13a2 2 0 002 2h7",
  key: "1chnfv"
}], ["path", {
  d: "M12 12l4.166 10 1.48-4.355L22 16.166 12 12z",
  key: "2kdk4z"
}], ["path", {
  d: "M18 18l3 3",
  key: "o3skm8"
}]]]);
export default Inspect;